export default __webpack_public_path__ + "static/media/protoAndGoLogoDark.15d04dcc.png";